import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

/** Server-formatted fields belong to the language in which they were fetched. */
export function usePortalLocaleQueries() {
  const { i18n } = useTranslation();
  const client = useQueryClient();
  const locale = i18n.resolvedLanguage || i18n.language;
  const previous = useRef(locale);
  useEffect(() => {
    if (previous.current === locale) return;
    previous.current = locale;
    // Invalidating alone retains a pending first fetch without cached data.
    // Cancel those obsolete reads too, then refresh active views and mark
    // inactive views stale so they reopen in the selected language.
    void client.cancelQueries().then(() => client.invalidateQueries());
  }, [client, locale]);
}
